import { render, staticRenderFns } from "./JBProposalOtherInsurance.vue?vue&type=template&id=198bb9aa"
import script from "./JBProposalOtherInsurance.vue?vue&type=script&lang=js"
export * from "./JBProposalOtherInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports